<!-- El contenedor es el que scrollea: su barra aparece al borde de la ventana.
     El alto del iframe lo fija el padre con la altura real que reporta el curso. -->
<div *ngIf="iframeUrl" class="iframe-container" #iframeContainer>
    <div class="iframe-overlay" [class.is-loaded]="iframeLoaded" (click)="closeIframe()"></div>
    <!-- allow: el player delega estos permisos a los iframes que contiene (SCORM, vídeos);
         sin ellos aquí, un SCORM no puede ir a pantalla completa ni reproducir audio solo. -->
    <iframe class="iframe-player" #playerIframe [src]="iframeUrl" frameborder="0" allowtransparency="true" allow="autoplay; fullscreen" allowfullscreen (load)="onIframeLoad()"></iframe>
</div>
  